import { FC, PropsWithChildren, useEffect, useMemo } from "react";
import { useRecoilValue } from "recoil";

import { useSimpleNavigation } from "@ryde/redux";
import {
  getLastNavigation,
  isProfileScopeLoadedSelector,
  routingEntityPath,
  RydeUiUnit,
  TPageRoute,
  TPermissionAction,
  useHasPermissions,
} from "@ryde/shared";

import { CompanyRedirectWrapper } from "./company-redirect-wrapper";

interface IRoutingUnit extends PropsWithChildren {
  entity: RydeUiUnit;
  action?: TPermissionAction;
}

export const RoutingUnit: FC<IRoutingUnit> = ({ children, entity, action }) => {
  const basePath = useMemo(() => routingEntityPath(entity), [entity]);
  const lastPath = getLastNavigation(`/${basePath}` as TPageRoute);
  const { navigatePageNotFound } = useSimpleNavigation();
  const isProfileScopeLoaded = useRecoilValue(isProfileScopeLoadedSelector);

  const { hasPermissions } = useHasPermissions({
    entity,
    action: action || "read",
  });

  useEffect(() => {
    if (isProfileScopeLoaded && !hasPermissions) {
      navigatePageNotFound();
    }
  }, [hasPermissions, isProfileScopeLoaded, navigatePageNotFound]);

  if (!isProfileScopeLoaded) {
    return null;
  }

  return (
    hasPermissions && (
      <CompanyRedirectWrapper basePath={lastPath || basePath}>
        {children}
      </CompanyRedirectWrapper>
    )
  );
};
